import React, { useCallback } from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { useSnackbar } from 'notistack';
import useDialog from '@dyl/hooks/useDialog';

const {
    REACT_APP_COGNITO_DOMAIN,
    REACT_APP_OIDC_REDIRECT_URI,
    REACT_APP_COGNITO_CLIENT_ID,
} = process.env;

export default function NavLogout({ ...other }) {
    const { enqueueSnackbar } = useSnackbar();

    const [ImperativeDialog, openDialog] = useDialog();

    const onLogOutClick = useCallback(async () => {
        const confirmed = await new Promise(resolve => openDialog(
            'Log out?',
            'Are you sure?',
            [
                { text: 'Cancel', onClick: () => resolve(false) },
                { text: 'Log out', onClick: () => resolve(true), destructive: true },
            ],
        ));

        if (!confirmed) return;
        try {
            sessionStorage.clear();
            localStorage.clear();

            const url = `https://${REACT_APP_COGNITO_DOMAIN}/logout?client_id=${REACT_APP_COGNITO_CLIENT_ID}&logout_uri=${REACT_APP_OIDC_REDIRECT_URI}logout`;
            window.location.href = url;
        }
        catch (error) {
            console.error(error);
            enqueueSnackbar('Error while logging out', { variant: 'error' });
        }
    }, []);

    return (
        <>
            <List component='nav' {...other}>
                <ListItem button onClick={onLogOutClick}>
                    <ListItemText primary='Log out' />
                </ListItem>
            </List>

            <ImperativeDialog />
        </>
    );
};